import { Associate } from '../associates/associate.model';
import { Employee } from '../associates/employee.model';
import { OemRooftopLink } from '../system/oem-rooftop-link.model';
import { QuoteHeader } from './quote-header.model';
import { ServiceGroup } from './service-group.model';
import { TransactionType } from '../common/transaction-type.model';
import { VehicleInspectionTask } from './vehicle-inspection-task.model';
import { VehicleInspection } from './vehicle-inspection.model';
import { WarrantySubmissionType } from './warranty-submission-type.model';
import { WorkOrder } from './work-order.model';

export class QuoteDetail {
  addedByPowerlane: boolean = null;
  additionalChargesSubTotal: number = null;
  associateId: string = null;
  campaignAddedBySystem: string = null;
  campaignNumber: string = null;
  communicatorPartPricingRequiredMessageCount: number = null;
  communicatorReadyForAdvisorMessageCount: number = null;
  createdFromSourceReference: number = null;
  createdFromSourceType: string = null;
  customerActioned: boolean = null;
  declined: number = null;
  declinedDatetime: Date = null;
  declinedInserted: number = null;
  embedded?: QuoteDetailEmbed = null;
  employeeId: string = null;
  excludeFromVcr: boolean = null;
  expirationDate: Date = null;
  gstAmount: number = null;
  id: number = null;
  insertedFromVehicleInspFlag: number = null;
  inspectionTaskId: number = null;
  ivcrNote: string = null;
  labourMatrixFlag: number = null;
  labourOpCode: string = null;
  labourRateChangedFlag: number = null;
  labourSubTotal: number = null;
  lineAddedFromServiceSchedule: number = null;
  mileageInterval: string = null;
  monthInterval: string = null;
  opCode: string = null;
  partKitsMaintenanceId: number = null;
  partsSubTotal: number = null;
  printFlag: number = null;
  pstAmount: number = null;
  quoteCreated: Date = null;
  quoteHeaderId: number = null;
  rate: number = null;
  rateType: string = null;
  recommendedHours: number = null;
  rooftopId: number = null;
  sequence: number = null;
  serviceGroupId: string = null;
  serviceName: string = null;
  shopSupplyFlag: string = null;
  sourceReferenceId: number = null;
  sourceType: string = null;
  subTotal: number = null;
  technicianGroupId: number = null;
  technicianGroupName: string = null;
  technicianId: string = null;
  totalAmount: number = null;
  transactionTypeId: string = null;
  warrantySubmissionTypeId: string = null;
  workHeaderId: number = null;

  constructor(obj?: QuoteDetail) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
export class QuoteToServiceAppointment {
  appointmentId: number = null;
  sequences: string = null;
  workOrderId?: number = null;

  constructor(obj?: QuoteToServiceAppointment) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
export class QuoteToWorkOrder {
  workOrderId: number = null;

  constructor(obj?: QuoteToWorkOrder) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

class QuoteDetailEmbed {
  employee?: Employee = null;
  employeeAssociate?: Associate = null;
  inspectionTask?: VehicleInspectionTask = null;
  inspectionTaskData?: VehicleInspection = null;
  quoteHeader?: QuoteHeader = null;
  oemRooftopLink?: OemRooftopLink = null;
  serviceGroup?: ServiceGroup = null;
  transactionType?: TransactionType = null;
  warrantySubmissionType?: WarrantySubmissionType = null;
  workOrder?: WorkOrder = null;
}
